import { useEffect, useState } from 'react';

/** Preferência de tema. O script inline do index.html aplica a mesma regra antes do primeiro paint. */
export type ThemePref = 'system' | 'light' | 'dark';
const KEY = 'vc-theme';

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

function apply(pref: ThemePref) {
  const dark = pref === 'dark' || (pref === 'system' && matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
}

export function useTheme(): [ThemePref, (p: ThemePref) => void] {
  const [pref, setPref] = useState<ThemePref>(read);
  useEffect(() => {
    apply(pref);
    if (pref !== 'system') return;
    const mq = matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => apply('system');
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [pref]);
  return [
    pref,
    (p) => {
      try {
        localStorage.setItem(KEY, p);
      } catch {
        /* armazenamento indisponível: vale só nesta sessão */
      }
      setPref(p);
    },
  ];
}

/** Acompanha o tema do sistema mesmo sem a tela de conta aberta. */
export function useSystemThemeSync() {
  useEffect(() => {
    const mq = matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      if (read() === 'system') apply('system');
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
}
